// @flow

import './styles/styles.scss';

import React from 'react';

import CostCalculatorForm, { CostCalculatorFormProvider } from './components/CostCalculatorForm';
import { FundProvider } from './components/FundSuggestor';
import CONFIGS from './configs/appConfig.json';
import { StaticLabelsProvider } from './global/context';

const App = () => {
  const { questions, labels } = CONFIGS;

  return (
    <CostCalculatorFormProvider questions={questions}>
      <FundProvider>
        <StaticLabelsProvider labels={labels}>
          <CostCalculatorForm />
        </StaticLabelsProvider>
      </FundProvider>
    </CostCalculatorFormProvider>
  );
};

export default App;
